import { useEffect, useState } from "react";
import api from "@/api/client";

export default function CustomerTerms() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { api.get("/commission-config").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  const slab1 = cfg ? cfg.slab1_pct : 18;
  const slab2 = cfg ? cfg.slab2_pct : 20;
  return (
    <div className="mx-auto max-w-3xl px-4 py-14" data-testid="customer-terms-page">
      <div className="text-xs uppercase tracking-[0.3em] text-[#F48E2E] font-bold mb-2">Policies</div>
      <h1 className="font-display text-4xl md:text-5xl mb-3">Customer Terms and Conditions</h1>
      <p className="text-gray-700 leading-relaxed mb-10">
        By placing an order on CityShor Pop-Up Bazaar you acknowledge and agree to the terms below. Please read them carefully.
      </p>

      <div className="space-y-4">
        <Section title="1. Product Representation">
          <p>Product images are for reference purposes only. The actual product may vary slightly in colour, texture, size, or appearance due to lighting, photography, screen resolution, or handcrafted variations.</p>
        </Section>
        <Section title="2. Agreement to Terms">
          <p>By placing an order, the customer agrees to all website Terms and Conditions, including the Return, Refund and Cancellation Policy and the Delivery Policy.</p>
        </Section>
        <Section title="3. Delivery Timelines">
          <p>Delivery timelines shown are estimates and may vary due to logistics, courier availability, festival load, or unforeseen circumstances. Please refer to the Delivery Policy for detailed zone-wise estimates.</p>
        </Section>
        <Section title="4. Prices, GST and Charges">
          <p>All prices shown are exclusive of GST unless otherwise mentioned. A 2 percent packaging charge and 18 percent GST are applied at checkout. Shipping charges are extra and are calculated automatically based on the delivery pincode.</p>
        </Section>
        <Section title="5. Return Shipping">
          <p>If a customer requests a return or exchange for reasons other than a seller error (damage, defect, wrong item, wrong size, missing accessories), the return shipping charges shall be borne by the customer. Returns without applicable shipping charges paid will not be accepted.</p>
        </Section>
        <Section title="6. Payments">
          <p>All order payments (Cash on Delivery, Online via Razorpay, and Bank Transfer) are received into the Cityshor LLP account. Cityshor LLP settles participating exhibitors weekly, minus the platform commission ({slab1}–{slab2} percent depending on order value).</p>
        </Section>
        <Section title="7. Order Fulfilment">
          <p>Exhibitors are required to ship the sold product directly to the customer within 24 hours via the Shiprocket shipment auto-created after order confirmation of order confirmation. In case of stock issues, CityShor will refund the customer within 3 to 5 business days.</p>
        </Section>
        <Section title="8. Customer Support">
          <p>For any query please write to Hi@cityShor.com or WhatsApp us. Support hours: Monday to Saturday, 11 AM to 7 PM IST.</p>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="p-6 bg-white rounded-2xl border border-gray-200">
      <h2 className="font-display text-2xl mb-2">{title}</h2>
      <div className="text-gray-700 leading-relaxed">{children}</div>
    </section>
  );
}
